import React from "react"
import styled from "styled-components"
import textStyles from "../utilities/textStyles"
import { space, color, style, fontSize, fontWeight } from "styled-system"
/*
// component that makes sure the space and color properties do not end up in the DOM:
import cleanElement from "clean-element"
import propTypes from "prop-types"
const CleanDiv = cleanElement("div")

CleanDiv.propTypes = {
  center: propTypes.bool,
  textStyle: propTypes.string
}
*/

const rem = n => n

const fontSizer = style({
  prop: "fontSize",
  key: "fontSizes",
  transformValue: n => n,
  scale: ["4rem"]
})

export default styled(
  ({ space, color, fontSize, fontWeight, ellipsis, ...props }) => (
    <div {...props} />
  )
)`
  ${props => rest => textStyles(props.textStyle || "body")};
  ${space};
  ${color};
  ${fontSize};
  ${fontWeight};
  ${props => (props.center ? `text-align: center` : "")};
  ${props => (props.inline ? `display: inline` : "")};
  ${props => (props.block ? `display: block` : "")};
  & a {
    text-decoration: none;
  }
  & a:hover {
  }
  ${({ ellipsis }) =>
    ellipsis &&
    `
  white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`
